@if (showExpand) {
    <div class="show-more-less-button" (click)="expand()">
        <span>{{ collapsedActionText }}</span>
        @if (showMoreCounter && !isEpcotEnabled) {
            <span class="more-counter"> ({{ remainingCount }}) </span>
        }
        @if (showChevron) {
            <vn-icon name="theme-right" class="right-icon" [size]="iconSize" />
        }
    </div>
}
@if (showCollapse) {
    <div class="show-more-less-button expanded" (click)="collapse()">
        <span>{{ sitecore.event.ShowLess }}</span>
        <vn-icon name="theme-right" class="right-icon" [size]="iconSize" />
    </div>
}
